
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/observasi",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/observasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/observasi"])
      });
    }
  